import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-050f8398")

_pushScopeId("data-v-050f8398")
const _hoisted_1 = { class: "admin-main-content" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "content-header" }, [
  /*#__PURE__*/_createVNode("h2", null, " 어신 커머스 DashBoard ")
], -1)
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-lg-3 col-6" }
const _hoisted_5 = { class: "small-box bg-info" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "inner" }, [
  /*#__PURE__*/_createVNode("h3", null, "352"),
  /*#__PURE__*/_createVNode("p", null, "미발주 내역")
], -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createVNode("i", { class: "ion ion-bag" })
], -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 바로가기 ")
const _hoisted_9 = /*#__PURE__*/_createVNode("i", { class: "fas fa-arrow-circle-right" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createStaticVNode("<div class=\"col-lg-3 col-6\" data-v-050f8398><div class=\"small-box bg-success\" data-v-050f8398><div class=\"inner\" data-v-050f8398><h3 data-v-050f8398>21,232만</h3><p data-v-050f8398>지난 매출 2월 1일 - 2월 28일</p></div><div class=\"icon\" data-v-050f8398><i class=\"ion ion-stats-bars\" data-v-050f8398></i></div><a href=\"#\" class=\"small-box-footer\" data-v-050f8398>More info <i class=\"fas fa-arrow-circle-right\" data-v-050f8398></i></a></div></div><div class=\"col-lg-3 col-6\" data-v-050f8398><div class=\"small-box bg-warning\" data-v-050f8398><div class=\"inner\" data-v-050f8398><h3 data-v-050f8398>12,342만</h3><p data-v-050f8398>이번달 매출 3월 1일 - 현재</p></div><div class=\"icon\" data-v-050f8398><i class=\"ion ion-person-add\" data-v-050f8398></i></div><a href=\"#\" class=\"small-box-footer\" data-v-050f8398>More info <i class=\"fas fa-arrow-circle-right\" data-v-050f8398></i></a></div></div><div class=\"col-lg-3 col-6\" data-v-050f8398><div class=\"small-box bg-danger\" data-v-050f8398><div class=\"inner\" data-v-050f8398><h3 data-v-050f8398>-42<sup style=\"font-size:20px;\" data-v-050f8398>%</sup></h3><p data-v-050f8398>전달 매출비교</p></div><div class=\"icon\" data-v-050f8398><i class=\"ion ion-pie-graph\" data-v-050f8398></i></div><a href=\"#\" class=\"small-box-footer\" data-v-050f8398>More info <i class=\"fas fa-arrow-circle-right\" data-v-050f8398></i></a></div></div>", 3)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          _hoisted_6,
          _hoisted_7,
          _createVNode(_component_router_link, {
            to: "/commerce/contract",
            class: "small-box-footer"
          }, {
            default: _withId(() => [
              _hoisted_8,
              _hoisted_9
            ]),
            _: 1
          })
        ])
      ]),
      _hoisted_10
    ])
  ]))
})